import React from 'react';
import './App.css';
import './override.min.css';
import 'font-awesome/css/font-awesome.min.css';
import { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Dashboard from './page/dashboard/dashboard';
import LeftNav from './layout/leftnav/leftnav';
import { CompanyProvider } from './component/CompanySelection/CompanyContext'
import AllPayments from './page/payment/AllPayments';
import IndividualPayments from './page/payment/IndividualPayments';
import MultiPartyPayments from './page/payment/multiparty/MultiPartyPayments';
import MultipleClaimantsPayments from './page/payment/multiparty/MultipleClaimantsPayments';
import ClaimantVendorPayments from './page/payment/multiparty/ClaimantVendorPayments';
import NotificationBanner from './component/NotificationBanner/NotificationBanner';
import VendorPayments from './page/payment/VendorPayments';
import Users from './page/users/Users';
import AddUser from './page/users/AddUser';
import EditUser from './page/users/EditUser';
import Roles from './page/role/Roles';
import CreateRole from './page/role/CreateRole';
import GlobalError from './page/errors/GlobalError';
import UnauthorizedUser from './page/errors/UnauthorizedUser';
import MobileHeader from './component/Mobile/MobileHeader';
import AutoLogout from './component/Modals/AutoLogout';
import { RefreshEvent } from './component/Refresh/RefreshEvent';
import ScrollToTop from './ScrollToTop';
import EditRole from './page/role/EditRole';
import AdminUser from './page/admin/AdminUsers';
import FeatureFlags from './page/admin/FeatureFlags';
import InternalRoles from './page/admin/InternalRoles';
import AddInternalRole from './page/admin/AddInternalRole';
import EditInternalRole from './page/admin/EditInternalRole';
import AdminAddUser from './page/admin/AdminAddUser';
import AdminEditUser from './page/admin/AdminEditUser';
import RegisterCompanies from './page/admin/Register/RegisterCompanies';
import RegisterCompany from './page/admin/Register/RegisterCompany';
import EditRegisteredCompany from './page/admin/Register/EditRegisteredCompany';

const EFUPDesktopContext = createContext();

export function useIsPageDesktop() {
	return useContext(EFUPDesktopContext);
}

function App() {
	const [isDesktop, setDesktop] = useState(window.innerWidth > 991);
	const updateMedia = () => {
		setDesktop(window.innerWidth > 991);
	};

	useEffect(() => {
		window.history.scrollRestoration = 'manual';
		window.addEventListener("resize", updateMedia);
		return () => window.removeEventListener("resize", updateMedia);
	});

	return (
		<EFUPDesktopContext.Provider value={isDesktop}>
			<CompanyProvider>
				<Router>
					<ScrollToTop>
						<Routes>
							<Route path="/" element={<Navigate replace to="/company/default/dashboard" />} />
							<Route path="/error" element={<GlobalError />} />
							<Route path="/unauthorizedUser" element={<UnauthorizedUser />} />
							<Route path="/company/:companyNumber" element={<Layout />}>
								<Route path="dashboard" element={<Dashboard />} />
								<Route path="payments" element={<AllPayments />} />
								<Route path="payments/individual" element={<IndividualPayments />} />
								<Route path="payments/multiParty" element={<MultiPartyPayments />} />
								<Route path="payments/multipleClaimants" element={<MultipleClaimantsPayments />} />
								<Route path="payments/claimantAndVendor" element={<ClaimantVendorPayments />} />
								<Route path="payments/vendor" element={<VendorPayments />} />
								<Route path="users" element={<Users />} />
								<Route path="users/add" element={<AddUser />} />
								<Route path="users/:username/edit" element={<EditUser />} />
								<Route path="roles" element={<Roles />} />
								<Route path="roles/add" element={<CreateRole />} />
								<Route path="roles/:roleName/edit" element={<EditRole />} />
								<Route path="*" element={<Navigate replace to="/" />} />
							</Route>
							<Route path="/system" element={<Layout />}>
								<Route path="users" element={<AdminUser />} />
								<Route path="featureFlags" element={<FeatureFlags />} />
								<Route path="internalRoles" element={<InternalRoles />} />
								<Route path="internalRoles/add" element={<AddInternalRole />} />
								<Route path="internalRoles/:roleUUID/edit" element={<EditInternalRole />} />
								<Route path="users/add" element={<AdminAddUser />} />
								<Route path="users/:username/edit" element={<AdminEditUser />} />
								<Route path="registerCompanies" element={<RegisterCompanies />} />
								<Route path="registerCompany" element={<RegisterCompany />} />
								<Route path="registerCompany/:companyNumber/edit" element={<EditRegisteredCompany />} />
							</Route>
							<Route path="*" element={<Navigate replace to="/" />} />
						</Routes>
					</ScrollToTop>
				</Router>
			</CompanyProvider>
		</EFUPDesktopContext.Provider>
	);
}

function Layout() {
	return (
		< div className="d-flex" id="wrapper" >
			<div className="border-end" id="sidebar-wrapper">
				<LeftNav />
			</div>
			<div id="page-content-wrapper">
				<ScrollToTop>
					<NotificationBanner />
					<MobileHeader />
					<Outlet />
					<AutoLogout />
					<RefreshEvent />
				</ScrollToTop>
			</div>
		</div >
	);
}

export default App;
